import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MainApiService from "../../../../services/mainApi.service";
import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { Chip } from "@mui/material";
import { IListCategories } from "../../../../models/list-category";

const BANK_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/ListCategory/";
const bankService = new MainApiService<IListCategories>(BANK_ROUTE);

const translationPath = "page.4uDlist.listCategory.";

const ListCategoryPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const columns: GridColDef<IListCategories>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "description",
      headerName: t(translationPath + "description") || "Description",
      renderCell: ({ row: { description } }) => {
        return description && description.length > 0 ? (
          <OverflowTooltip
            text={description}
            tooltip={description}
            textTransform="none"
            variant="body2"
          />
        ) : (
          "-"
        );
      },
    },
    {
      field: "enable",
      headerName: t(translationPath + "status") || "Status",
      maxWidth: 150,
      renderCell: ({ row: { enable } }) => {
        return (
          <Chip
            label={
              enable
                ? t(translationPath + "active")
                : t(translationPath + "inactive")
            }
            color={enable ? "success" : "error"}
          />
        );
      },
    },
  ];

  const handleRowClick = (params: GridRowParams<IListCategories>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  const handleAdd = () => {
    navigate("new");
  };

  return (
    <Table<IListCategories>
      showDefaultMacroFilters={false}
      service={bankService}
      columns={columns}
      title={t(translationPath + "title")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={
        t(translationPath + "search") || "Search for a list classification"
      }
      addButtonLabel={t(translationPath + "add") || "Add List Classification"}
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default ListCategoryPage;
